import Vue from 'vue';
import { API_BASE_URL } from '@/config';
export default {
  pubmed_article_dataset_create (query) {
    return Vue.http.post(API_BASE_URL + 'v1/pubmed/article/dataset/create?' + query);
  }
};
